<template>
  <div>
    <vx-card v-can="'view-user-role'" titleIcon="FilterIcon" ref="filterCard" title="Filters" class="user-list-filters mb-8" :collapse-action="true">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-100 text-bold">Name</label>

          <vs-input type="search"  placeholder="Search.." v-model="filters['name']" class="mb-4 md:mb-0 w-full"/>
        </div>
      </div>

      <div class="vx-row mt-5">
        <div class="vx-col w-full ml-auto">
          <vs-button class="float-right mr-4" size="small"
                     color="danger" type="border" icon-pack="feather" v-on:click="filters={}" >CLEAR</vs-button>
        </div>
      </div>
    </vx-card>
    <div class="vx-row">

      <div class="vx-col w-full">
        <vx-card title="User Roles" v-can:any="['create-user-role', 'view-user-role']">
          <template slot="actions">
            <vs-button  v-can="'create-user-role'" @click="createGroupPopUp" class="" color="primary" type="filled">Create Role</vs-button>
          </template>
          <div slot="no-body" class="mt-4">
            <vs-table v-can="'view-user-role'" :max-items="(meta.per_page) ? meta.per_page : 10" @sort="handleSort" :sst="true" :data="groups" stripe class="table-dark-inverted table-auto vs-con-loading__container">>

              <template slot="thead">
                <vs-th sort-key="name">NAME</vs-th>
                <vs-th>DESCRIPTION</vs-th>
                <vs-th v-can="'edit-user-role'" >ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>
                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].description">
                    {{ data[indextr].description || 'N/A' }}
                  </vs-td>
                  <vs-td v-can="'edit-user-role'">
                    <div class="vx-row">
                      <vx-tooltip text="Edit" class="ml-5">
                        <!--                    <vs-button @click="popupActive=true"-->
                        <vs-button @click="onClickUserEdit(data[indextr].id)"
                                   size="small" color="primary" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                      </vx-tooltip>
<!--                      <vx-tooltip class="ml-3" text="Delete" position="left">-->
<!--                        &lt;!&ndash;                    <vs-button @click="popupActive=true"&ndash;&gt;-->
<!--                        <vs-button  @click="openConfirm()"-->
<!--                                   radius color="danger" type="border" icon-pack="feather" icon="icon-delete"></vs-button>-->
<!--                      </vx-tooltip>-->
                    </div>
                  </vs-td>
                </vs-tr>
              </template>

            </vs-table>

            <vs-pagination :total="(meta.last_page)? meta.last_page : 0" v-model="page" class="p-5"></vs-pagination>

          </div>
        </vx-card>
      </div>
    </div>
    <create-staff-group-pop-up ref="createStaffGroupPopUp"/>
    <update-staff-group-pop-up ref="updateStaffGroupPopUp"/>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import Vue from 'vue';
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import Filter from '@/mixins/filter';
  import CreateStaffGroupPopUp from '@/components/popups/group/CreateStaffGroupPopUp'
  import UpdateStaffGroupPopUp from '@/components/popups/group/UpdateStaffGroupPopUp'

  const PermissionRepository = RepositoryFactory.get('permissions')
  const RolesRepository = RepositoryFactory.get('roles')

export default {
  name: 'AllUsersList',
  data () {
    return {
      dataSource : [],
      fields: {},
      checkedNodes: [],
      groups: [],
      selected: [],
      popupActive: false,
      createGroupPopupActive: false,
      popupTitle: '',
      editActive: false,
      edit: null,
      editProp: {},
      activeConfirm: false,
      checkBox1: false,
      treeData: [
        {
          title: 'Inventory',
          expanded: true,
          children: [
            {
              title: 'Traded Goods',
              expanded: true,
              children: [
                {
                  title: 'Traded Goods Stock Check'
                }, {
                  title: 'Order Traded Goods'
                }, {
                  title: 'Traded Goods Order History'
                }
              ]
            }, {
              title: 'Raw Materials',
              children: [
                {
                  title: '<span style=\'color: red\'>Raw Material Price Check</span>'
                }, {
                  title: '<span style=\'color: red\'>Order Raw Materials</span>'
                }
              ]
            }
          ]
        }
      ],
      filters: {},
      page : 1,
      total: 0,
      meta : {},
      sort : '',
    }
  },
  async mounted () {
    this.$refs.filterCard.isContentCollapsed = true
    this.$refs.filterCard.maxHeight = '1.5rem'
    this.loadGroups()
  },
  components: {
    'v-select': vSelect,
    CreateStaffGroupPopUp,
    UpdateStaffGroupPopUp
  },
  mixins : [Filter],
  methods: {
    async refreshData () {
      this.loadGroups()
    },
    async loadGroups() {
      this.$vs.loading()
      const {data} = await RolesRepository.get(this.page,this.filterQuery,10, this.sort)
      this.groups = data.data
      this.meta = data.meta
      this.$vs.loading.close()
    },
    async onClickUserEdit (id) {
      await this.$refs.updateStaffGroupPopUp.openPopup(id)
    },
    async createGroupPopUp () {
      await this.$refs.createStaffGroupPopUp.openPopup()
    },
    openConfirm () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Remove Confirm',
        text: 'Are you sure you want to permanently remove this organization?',
        accept: this.acceptAlert
      })
    },
    acceptAlert () {
      this.$vs.notify({
        color: 'danger',
        title: 'Deleted Organization',
        position:'top-right',
        text: 'The selected organization was successfully deleted'
      })
    },

    filterQueryUpdate (){
      this.loadGroups()
    },

    handleChangePage(page) {
      this.page=page;
      this.loadGroups()
    },

    handleSort(key, active) {
      if(key){
        active = (active==='desc')? "-":'';
        this.sort=active+key;
        this.loadGroups()
      }

    }

  },
  watch : {
    page(){
      this.loadGroups()
    }
  }
}
</script>


<style scoped>
  .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  }
  .control_wrapper {
    display: block;
    max-width: 350px;
    max-height: 350px;
    margin: auto;
    overflow: auto;
    border: 1px solid #dddddd;
    border-radius: 3px;
  }
</style>


<style lang="scss">
  @import "@/assets/scss/vuexy/extraComponents/tree.scss";

  button.btn-async{
    background: rgba(var(--vs-warning),0.15);
  }

  button.btn-delete{
    background: rgba(var(--vs-danger),0.15);
  }
</style>
